// extracted by mini-css-extract-plugin
export var buttonPlay = "MediaPlayer-module--buttonPlay--d675f";
export var cardsWithVideo = "MediaPlayer-module--cardsWithVideo--2f071";
export var fadeInAnimation = "MediaPlayer-module--fadeInAnimation--6de0a";
export var greetingCard = "MediaPlayer-module--greetingCard--ed720";
export var hidden = "MediaPlayer-module--hidden--0c770";
export var insightsPage = "MediaPlayer-module--insightsPage--19dd2";
export var mediaPlayer = "MediaPlayer-module--mediaPlayer--d446c";
export var modal = "MediaPlayer-module--modal--57b38";
export var poster = "MediaPlayer-module--poster--e4437";
export var testimonial = "MediaPlayer-module--testimonial--e7770";
export var video = "MediaPlayer-module--video--96154";
export var videoService = "MediaPlayer-module--videoService--4cf32";
export var videoWrapper = "MediaPlayer-module--videoWrapper--4fec5";